import React, {useEffect, useState} from "react";
import {ProductListFilterItemBoolean} from "@connox/typescript-library";
import {useProductListContext} from "../productListProvider/ProductListProvider";
import {useTranslation} from "react-i18next";
import {useMediaQuery} from "react-responsive";
import ToggleSwitch from "../../atoms/ToggleSwitch";

type ProductFilterBooleanProps = {
  item: ProductListFilterItemBoolean;
  onSelect: (value: boolean) => void;
};

const ProductFilterBoolean: React.FC<ProductFilterBooleanProps> = ({item, onSelect}) => {
  const {t} = useTranslation();
  const {state, dispatch} = useProductListContext();
  const isMobile = useMediaQuery({query: "(max-width: 940px)"});
  const [isSelected, setIsSelected] = useState<boolean>(false);

  useEffect(() => {
    setIsSelected(!!state.filters[item.field]);
  }, [state.filters[item.field]]);

  const toggleFilter = (checked: boolean) => {
    setIsSelected(checked);
    if (isMobile) {
      onSelect(checked);

      return;
    }
    if (checked) {
      dispatch({type: "SET_FILTER", payload: {field: item.field, value: true}});
    } else {
      dispatch({type: "REMOVE_FILTER", payload: {field: item.field}});
    }
  };

  const count = item.values.get(ProductListFilterItemBoolean.trueValueId)?.count ?? 0;
  const title = () => {
    if (count) {
      return (
        <>
          <span className="filter-item__boolean__title" title={`${item.name || t<string>(`product.${item.field}`)}`}>
            {`${item.name || t<string>(`product.${item.field}`)}`}
          </span>
          <span className="filter-item__count">({count})</span>
        </>
      );
    }

    return item.name || t(`product.${item.field}`);
  };

  if (!count) {
    return null;
  }

  return (
    <div className="filter-item filter-item__boolean">
      <ToggleSwitch onChange={toggleFilter} checked={isSelected} disabled={!count}>
        {title()}
      </ToggleSwitch>
    </div>
  );
};

export default ProductFilterBoolean;
